import devConfig from './envs/dev.config';
import stgConfig from './envs/stg.config';
import prodConfig from './envs/prod.config';

const CONFIG = (() => {
  switch (import.meta.env.MODE) {
    case 'development':
      return devConfig;
    case 'staging':
      return stgConfig;
    case 'production':
      return prodConfig;
    default:
      return devConfig;
  }
})();

export const {
  services: apiConfig,
  integrations: integrationsConfig,
  constants: constantsConfig,
  assets: assetsConfig,
} = CONFIG;
